
import { Subscription } from 'rxjs/rx';
import { Component } from '@angular/core';
import { NavController, NavParams, ViewController, ModalController } from 'ionic-angular';
import { Keyboard } from '@ionic-native/keyboard';
import { CustomAlert } from '../../components/custom-alert.component';
//Providers
import { UtilProvider } from '../../providers/util-provider';
import { AuthProvider } from '../../providers/auth-provider';
import { ConfigProvider } from '../../providers/config-provider';
//Pages
import { ExpositorVideoPage } from './../expositor-video/expositor-video';
//Models
import { Expositor } from '../../models/expositor/expositor.model';
import { Arquivo } from './../../models/expositor/arquivo.model';
import { User } from '../../models/user.model';
import { Congresso } from '../../models/congresso.model';

@Component({
  selector: 'page-expositor-arquivos',
  templateUrl: 'expositor-arquivos.html'
})
export class ExpositorArquivosPage {

  public expositor: Expositor;
  public Arquivos:Array<Arquivo> = [];
  public Videos:Array<Arquivo> = [];
  public user: User;

  private usuarioPermitido: boolean = false;
  private congresso: Congresso;
  
  private onShowSubscription: Subscription;
  private onHideSubscription: Subscription;

  constructor(
    public navCtrl: NavController, 
    public navParams: NavParams,
    public utilProvider: UtilProvider,
    public viewCtrl: ViewController,
    public authProvider: AuthProvider,
    private keyboard: Keyboard,
    private configProvider: ConfigProvider,
    private modalCtrl: ModalController,
    private alert: CustomAlert
  ) {
    this.user = JSON.parse(localStorage.getItem('user')) as User;
    this.congresso = JSON.parse(localStorage.getItem('congresso')) as Congresso;
  }

  ionViewDidLoad() {
    this.get();
  }

  get() {
    let self = this;
    self.expositor = self.navParams.get("expositor");

    self.expositor.Arquivos.forEach(x => {
      if (x.FilePath) {
        self.Arquivos.push(x);        
      } else {
        self.Videos.push(x);
      }
    });
  }

  ionViewDidEnter() {
    this.keyboard.disableScroll(true);
    let appEl = <HTMLElement>(document.getElementsByTagName('ION-APP')[0]),
        appElHeight = appEl.clientHeight;

    this.onShowSubscription =  this.keyboard.onKeyboardShow().subscribe((e) => {
        appEl.style.height = ((appElHeight) - (<any>e).keyboardHeight) + 'px';
    });

    this.onHideSubscription = this.keyboard.onKeyboardHide().subscribe((e) => {
        appEl.style.height = '100%';
    });
  }

  dismiss() {
    let appEl = <HTMLElement>(document.getElementsByTagName('ION-APP')[0]),
        appElHeight = appEl.clientHeight;
        appEl.style.height = '100%';
      this.keyboard.disableScroll(false);
      this.onShowSubscription.unsubscribe();
      this.onHideSubscription.unsubscribe();
      this.viewCtrl.dismiss();
  }

  video(a: Arquivo) {

    let self = this;

    if (self.getValidFile(a)) {
      self.openVideo(a);
    }
    else if (!self.authProvider.isAuthorized(true)) {
      self.authProvider.isAuthorized();
    }
    else if (!self.usuarioPermitido) {
      self.alert.showAlert('Aviso', 'Conteúdo disponível apenas para inscritos no congresso ' + self.congresso.Ano + '.');
    }
    else {
      this.alert.showAlert('Aviso', 'Vídeo disponível apenas para prescritores.');
    }
  }

  openVideo(a: Arquivo) {

    let self = this;

    if (self.utilProvider.isConnected(true)) {
      let modal = this.modalCtrl.create(ExpositorVideoPage, {
          id: a.Id,
          urlVideo: a.VideoUrl,
          titleVideo: a.Descricao,
          titlePage: self.expositor.Nome
      });
      modal.present();                    
    }
  }
  
  download(a: Arquivo) {
    this.utilProvider.loadingShow();
    let self = this;

    if (self.getValidFile(a)) {
      self.downloadFile(a);
      this.utilProvider.loadingHide();
    }
    else if (!self.authProvider.isAuthorized(true)) {
      self.authProvider.isAuthorized();
      this.utilProvider.loadingHide();
    }
    else if (!self.usuarioPermitido) {
      self.alert.showAlert('Aviso', 'Conteúdo disponível apenas para inscritos no congresso ' + self.congresso.Ano + '.');
      this.utilProvider.loadingHide();
    }
    else {
      this.alert.showAlert('Aviso', 'Arquivo disponível apenas para prescritores.');
      this.utilProvider.loadingHide();
    }
  }

  downloadFile(a: Arquivo) {

    let self = this;

    var link = document.createElement('a');
    link.href = self.configProvider.url.Cientifico + a.FilePath;
    link.target="blank";
    link.download = a.Descricao;
    link.dispatchEvent(new MouseEvent('click'));
  }

  getValidFile(a: Arquivo) {
    let self = this;
    self.checkLoggedUser();
    return self.authProvider.isAuthorized(true) && self.usuarioPermitido && (!a.Prescritor || (a.Prescritor && self.user.Prescritor));
  }

  checkLoggedUser() {
    let self = this;
    if (self.authProvider.isAuthorized(true) && !self.user) {
      self.user = JSON.parse(localStorage.getItem('user')) as User;
    }
    else if (!self.authProvider.isAuthorized(true) && self.user) {
      self.user = undefined;
    }

    self.usuarioPermitido = self.user && self.user.InscricaoPaga;    
  }

}



// WEBPACK FOOTER //
// ./src/pages/expositor-arquivos/expositor-arquivos.ts